import { tooltipClasses } from "@mui/material";
import { GridRowId } from "@mui/x-data-grid";
import { ReactElement, useMemo } from "react";
import { TbHistory, TbInfoCircle } from "react-icons/tb";

import { softColors } from "@/constants/colors";
import { NoMaxWidthTooltip } from "@/pages/DriverStatus.tsx/components/DriverStatusColumnTooltip";
import HotelStatusTooltip from "@/pages/HotelPlanning/arrival/components/table/components/HotelStatusTooltip";
import {
    ClinicTasksEditableFields,
    useClinicArrivalTasksGridInitialVal,
    useClinicArrivalTasksGridIsChanged,
} from "@/stores/use-clinic-arrival-tasks-grid";

function ClinicArrivalTasksHistoryInfo<T>({
    field,
    id,
    renderHistoryComp,
}: {
    field: string;
    id: GridRowId;
    renderHistoryComp: (value: T) => ReactElement<Record<string, unknown>>;
}) {
    const isChanged = useClinicArrivalTasksGridIsChanged(id, field as keyof ClinicTasksEditableFields);
    const initialVal = useClinicArrivalTasksGridInitialVal(id, field as keyof ClinicTasksEditableFields) as T;
    const tooltipInfo = useMemo(() => {
        if (!isChanged) return false;

        return {
            ...softColors.brown,
            tooltip: {
                title: "İlk Veri Değeri",
                description: String(initialVal),
                descriptionComp: renderHistoryComp(initialVal),
            },
            component: () => TbHistory,
        };
    }, [isChanged, initialVal, renderHistoryComp]);

    return (
        tooltipInfo && (
            <NoMaxWidthTooltip
                arrow
                sx={{
                    [`& .${tooltipClasses.tooltip}`]: {
                        backgroundColor: "white",
                        border: "none",
                        padding: "0px !important",
                        fontSize: 12,
                        maxWidth: "200px !important",
                    },
                }}
                title={<HotelStatusTooltip status={tooltipInfo} />}
            >
                <div className="max-w-fit absolute top-1 right-2 z-50 max-h-fit !ml-auto">
                    <TbInfoCircle />
                </div>
            </NoMaxWidthTooltip>
        )
    );
}

export default ClinicArrivalTasksHistoryInfo;
